// A changed measurement must not leave the previous suggestion silently valid.
function setHiDreamFitPurchaseState(state) {
  const notice = document.querySelector('[data-hd-fit-purchase-notice]');
  if (!notice || (state === 'incomplete' && !notice.dataset.fitState)) return;
  notice.dataset.fitState = state;
  notice.hidden = state === 'matched';
  notice.querySelector('input').checked = false;
  notice.querySelector('[data-hd-fit-purchase-copy]').textContent = state === 'incomplete'
    ? 'Your measurements have changed. The previous size suggestion is no longer confirmed. Complete the fit guide or check the measurements yourself before ordering.'
    : 'The fit guide could not confirm a match. Your selected size has not been verified. Check the measurements or contact us before ordering.';
}

document.addEventListener('submit', (event) => {
  const notice = document.querySelector('[data-hd-fit-purchase-notice]');
  // Shopify's variant input is named "id", which shadows HTMLFormElement.id.
  if (!notice || notice.hidden || event.target.getAttribute('id') !== notice.dataset.productForm) return;
  const checkbox = notice.querySelector('input');
  if (checkbox.checked) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  notice.scrollIntoView({ block: 'center', behavior: 'instant' });
  checkbox.focus({ preventScroll: true });
}, true);

class HiDreamProductDetails {
  constructor(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll('[data-hd-product-tab]'));
    this.panels = Array.from(root.querySelectorAll('[data-hd-product-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab.dataset.hdProductTab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event));
    });
  }

  select(name, focus = false) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.hdProductTab === name;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      if (active && focus) tab.focus();
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.hdProductPanel !== name;
    });
  }

  onKeydown(event) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();
    const current = this.tabs.indexOf(event.currentTarget);
    let next = current;

    if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = this.tabs.length - 1;

    this.select(this.tabs[next].dataset.hdProductTab, true);
  }
}

document.querySelectorAll('[data-hd-product-details]').forEach((root) => {
  new HiDreamProductDetails(root);
});

class HiDreamCarrierFitQuiz {
  constructor(root) {
    this.root = root;
    this.weightButtons = Array.from(root.querySelectorAll('[data-hd-carrier-weight]'));
    this.priorityButtons = Array.from(root.querySelectorAll('[data-hd-carrier-priority]'));
    this.result = root.querySelector('[data-hd-carrier-result]');
    this.resultTitle = root.querySelector('[data-hd-carrier-result-title]');
    this.resultSize = root.querySelector('[data-hd-carrier-result-size]');
    this.resultCopy = root.querySelector('[data-hd-carrier-result-copy]');
    this.resultSpec = root.querySelector('[data-hd-carrier-result-spec]');
    this.weight = '';
    this.priority = '';

    this.weightButtons.forEach((button) => {
      button.addEventListener('click', () => this.selectWeight(button.dataset.hdCarrierWeight));
    });

    this.priorityButtons.forEach((button) => {
      button.addEventListener('click', () => this.selectPriority(button.dataset.hdCarrierPriority));
    });
  }

  selectWeight(weight) {
    this.weight = weight;
    this.weightButtons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.hdCarrierWeight === weight));
    });

    const outOfRange = weight === 'over';
    if (outOfRange) this.priority = '';

    this.priorityButtons.forEach((button) => {
      button.disabled = outOfRange;
      button.setAttribute('aria-pressed', String(!outOfRange && button.dataset.hdCarrierPriority === this.priority));
    });

    if (outOfRange) {
      this.showResult({
        size: '—',
        title: 'Neither size is a safe recommendation',
        copy: 'This carrier is rated up to 15.4 lb. Choose a larger carrier designed for your pet’s weight and measurements.',
        spec: 'Do not size down',
        outOfRange: true,
      });
      return;
    }

    if (this.priority) this.updateRecommendation();
    else this.hideResult();
  }

  selectPriority(priority) {
    if (!this.weight || this.weight === 'over') return;

    this.priority = priority;
    this.priorityButtons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.hdCarrierPriority === priority));
    });
    this.updateRecommendation();
  }

  updateRecommendation() {
    const size = this.weight === 'mid' || this.priority === 'room' ? 'L' : 'M';
    const isMedium = size === 'M';
    this.selectProductSize(size);
    this.showResult({
      size,
      title: `Size ${size} is your starting point`,
      copy: isMedium
        ? 'We selected it above. Confirm your pet can stand, turn and lie naturally inside.'
        : 'We selected it above. It adds 3.1 inches of length; confirm the larger exterior size is allowed for your flight.',
      spec: isMedium
        ? '13.8 × 11.0 × 9.4 in / 35 × 28 × 24 cm · Up to 13.2 lb / 6 kg'
        : '16.9 × 11.0 × 9.8 in / 43 × 28 × 25 cm · Up to 15.4 lb / 7 kg',
      outOfRange: false,
    });
  }

  selectProductSize(size) {
    const input = Array.from(document.querySelectorAll('variant-selects input[type="radio"]')).find((candidate) => {
      return candidate.value === size && candidate.name.trim().toLowerCase().startsWith('size');
    });

    if (input && !input.checked) input.click();
  }

  showResult({ size, title, copy, spec, outOfRange }) {
    if (!this.result) return;
    setHiDreamFitPurchaseState(outOfRange ? 'unconfirmed' : 'matched');
    this.result.hidden = false;
    this.result.classList.toggle('is-out-of-range', outOfRange);
    this.resultTitle.textContent = title;
    this.resultSize.textContent = size;
    this.resultCopy.textContent = copy;
    this.resultSpec.textContent = spec;
  }

  hideResult() {
    if (this.result) this.result.hidden = true;
    setHiDreamFitPurchaseState('incomplete');
  }
}

document.querySelectorAll('[data-hd-carrier-fit]').forEach((root) => {
  new HiDreamCarrierFitQuiz(root);
});

const HD_FIT_RULES = {
  'valley-series-dog-harness-vest-kit': {
    fields: ['Pet weight', 'Chest'],
    primary: 'Chest',
    prefer: 'larger',
    allowLowerWeight: true,
    resultNote: 'Chest decides the size',
  },
  'valley-series-dog-harness-walk-kit': {
    fields: ['Pet weight', 'Chest'],
    primary: 'Chest',
    prefer: 'larger',
    allowLowerWeight: true,
    resultNote: 'Chest decides the size',
  },
  'colourful-series-y-dog-harness-bundle': {
    fields: ['Pet weight', 'Chest'],
    primary: 'Chest',
    prefer: 'larger',
    allowLowerWeight: true,
    resultNote: 'Chest decides the size',
  },
  'valley-dog-head-collar-bundle': {
    fields: ['Nose loop', 'Neck'],
    primary: 'Nose loop',
    prefer: 'smaller',
    resultNote: 'Both ranges must fit',
  },
  'cat-surgery-recovery-suit': {
    fields: ['Back length', 'Chest'],
    primary: 'Back length',
    prefer: 'smaller',
    resultNote: 'Back length comes first',
  },
  'taper-elizabethan-ring': {
    fields: ['Neck', 'Cone depth'],
    primary: 'Neck',
    capacityFields: ['Cone depth'],
    prefer: 'smaller',
    resultNote: 'Check neck and nose length',
  },
  'mesh-elizabethan-ring': {
    fields: ['Neck', 'Cone depth'],
    primary: 'Neck',
    capacityFields: ['Cone depth'],
    prefer: 'smaller',
    resultNote: 'Check neck and nose length',
  },
  'flower-taper-elizabethan-ring': {
    fields: ['Neck', 'Cone depth'],
    primary: 'Neck',
    capacityFields: ['Cone depth'],
    prefer: 'smaller',
    resultNote: 'Check neck and nose length',
  },
  'soft-tapered-elizabethan-ring': {
    fields: ['Neck', 'Cone depth'],
    primary: 'Neck',
    capacityFields: ['Cone depth'],
    prefer: 'smaller',
    resultNote: 'Check neck and nose length',
  },
  'dog-cooling-collar': {
    fields: ['Neck length', 'Pet weight'],
    primary: 'Neck length',
    capacityFields: ['Neck length'],
    prefer: 'smaller',
    resultNote: 'Check neck and weight',
  },
  'flower-shaped-elizabethan-rings': {
    fields: ['Neck', 'Pet weight'],
    primary: 'Neck',
    prefer: 'smaller',
    allowLowerWeight: true,
    resultNote: 'Neck decides the fit',
  },
};

const HD_FIT_FIELD_COPY = {
  'Pet weight': {
    title: 'What does your pet weigh?',
    copy: 'Enter their current weight, not an estimate based on breed.',
  },
  Chest: {
    title: 'What is your pet’s chest measurement?',
    copy: 'Measure the widest point while your pet is standing.',
  },
  Neck: {
    title: 'What is your pet’s neck measurement?',
    copy: 'Measure where the product will sit, without pulling the tape tight.',
  },
  'Neck length': {
    title: 'What is your pet’s neck measurement?',
    copy: 'Measure around the neck where the cooling collar will sit.',
  },
  'Nose loop': {
    title: 'What is your pet’s nose-loop measurement?',
    copy: 'Measure around the muzzle without pulling the tape tight.',
  },
  'Back length': {
    title: 'What is your pet’s back length?',
    copy: 'Measure from the base of the neck to the base of the tail.',
  },
  'Cone depth': {
    title: 'How far is it from neck to nose?',
    copy: 'The cone must extend beyond this measurement.',
  },
};

class HiDreamFitQuiz {
  constructor(root) {
    this.root = root;
    this.guide = root.closest('.hd-fit-guide');
    this.stepOne = root.querySelector('[data-hd-fit-step-one]');
    this.stepTwo = root.querySelector('[data-hd-fit-step-two]');
    this.stepOneTitle = root.querySelector('[data-hd-fit-step-one-title]');
    this.stepOneCopy = root.querySelector('[data-hd-fit-step-one-copy]');
    this.stepTwoTitle = root.querySelector('[data-hd-fit-step-two-title]');
    this.stepTwoCopy = root.querySelector('[data-hd-fit-step-two-copy]');
    this.result = root.querySelector('[data-hd-fit-result]');
    this.resultTitle = root.querySelector('[data-hd-fit-result-title]');
    this.resultSize = root.querySelector('[data-hd-fit-result-size]');
    this.resultCopy = root.querySelector('[data-hd-fit-result-copy]');
    this.resultSpec = root.querySelector('[data-hd-fit-result-spec]');
    this.resultNote = root.querySelector('[data-hd-fit-result-note]');
    this.rows = this.readRows();
    this.handle = root.dataset.hdProductHandle || '';
    this.inputs = new Map();
    this.units = new Map();
    this.hints = new Map();
    this.firstChoice = '';
    this.secondChoice = '';

    if (!this.rows.length) {
      this.root.hidden = true;
      return;
    }

    this.rule = this.getRule();
    const hasComparableSizes = this.rows.length > 1 && this.rule
      && this.rule.fields.every((label) => this.rows.every((row) => row.cells.some((cell) => cell.label === label)));
    if (hasComparableSizes) this.buildSizeFlow();
    else this.buildConfirmationFlow();
  }

  readRows() {
    const measurementPriority = [
      'Nose loop',
      'Chest',
      'Neck',
      'Body length',
      'Back length',
      'Carrier dimensions',
      'Backpack dimensions',
      'Bag dimensions',
      'Published bag size',
      'Pouch dimensions',
      'Length',
      'Cone depth',
    ];

    return Array.from(this.guide.querySelectorAll('.hd-fit-guide__table-wrap tbody tr')).map((row) => {
      const cells = Array.from(row.querySelectorAll('td')).map((cell) => ({
        label: cell.dataset.label || '',
        text: cell.innerText.replace(/\s+/g, ' ').trim(),
      }));
      const measurement = measurementPriority
        .map((label) => cells.find((cell) => cell.label === label))
        .find(Boolean) || cells.find((cell) => cell.label && cell.label !== 'Pet weight' && !/weight/i.test(cell.label));

      return {
        size: row.querySelector('th')?.textContent.trim() || 'One size',
        weight: cells.find((cell) => cell.label === 'Pet weight'),
        measurement,
        cells,
      };
    });
  }

  getRule() {
    if (HD_FIT_RULES[this.handle]) return HD_FIT_RULES[this.handle];
    if (this.rows.length < 2 || !this.rows.every((row) => row.weight && row.measurement)) return null;
    return {
      fields: ['Pet weight', this.rows[0].measurement.label],
      primary: this.rows[0].measurement.label,
      prefer: 'larger',
      allowLowerWeight: true,
      resultNote: `${this.rows[0].measurement.label} decides the size`,
    };
  }

  buildSizeFlow() {
    const [firstField, secondField] = this.rule.fields;
    this.configureStepCopy(this.stepOneTitle, this.stepOneCopy, firstField, 1);
    this.configureStepCopy(this.stepTwoTitle, this.stepTwoCopy, secondField, 2);
    this.stepOne.classList.add('hd-fit-entry');
    this.stepTwo.classList.add('hd-fit-entry', 'is-disabled');
    this.stepOne.append(this.createNumericInput(firstField, false));
    this.stepTwo.append(this.createNumericInput(secondField, true));
  }

  configureStepCopy(titleElement, copyElement, field, number) {
    const copy = HD_FIT_FIELD_COPY[field] || {
      title: `Enter the ${field.toLowerCase()}`,
      copy: 'Use a current measurement taken before ordering.',
    };
    titleElement.textContent = `${number}. ${copy.title}`;
    copyElement.textContent = copy.copy;
  }

  createNumericInput(field, disabled) {
    const dimension = field === 'Pet weight' ? 'weight' : 'length';
    const defaultUnit = dimension === 'weight' ? 'lb' : 'in';
    const metricUnit = dimension === 'weight' ? 'kg' : 'cm';
    const id = `HdFit-${this.handle}-${field.replace(/[^a-z0-9]+/gi, '-')}`;
    const shell = document.createElement('div');
    const control = document.createElement('div');
    const input = document.createElement('input');
    const units = document.createElement('div');
    const hint = document.createElement('span');

    shell.className = 'hd-fit-entry__shell';
    control.className = 'hd-fit-entry__control';
    units.className = 'hd-fit-entry__units';
    units.setAttribute('role', 'group');
    units.setAttribute('aria-label', `${field} unit`);
    hint.className = 'hd-fit-entry__hint';
    hint.id = `${id}-hint`;

    input.id = id;
    input.type = 'number';
    input.inputMode = 'decimal';
    input.min = '0.1';
    input.step = '0.1';
    input.autocomplete = 'off';
    input.disabled = disabled;
    input.dataset.hdFitInput = field;
    input.setAttribute('aria-label', field);
    input.setAttribute('aria-describedby', hint.id);

    [defaultUnit, metricUnit].forEach((unit) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = unit;
      button.dataset.hdFitUnit = unit;
      button.dataset.hdFitField = field;
      button.setAttribute('aria-pressed', String(unit === defaultUnit));
      button.disabled = disabled;
      button.addEventListener('click', () => this.changeUnit(field, unit));
      units.append(button);
    });

    input.addEventListener('input', () => this.handleNumericInput(field));
    control.append(input, units);
    shell.append(control, hint);
    this.inputs.set(field, input);
    this.units.set(field, defaultUnit);
    this.hints.set(field, hint);
    this.updateFieldHint(field);
    return shell;
  }

  changeUnit(field, nextUnit) {
    const input = this.inputs.get(field);
    const currentUnit = this.units.get(field);
    if (!input || currentUnit === nextUnit) return;
    const currentValue = Number.parseFloat(input.value);
    if (Number.isFinite(currentValue) && currentValue > 0) {
      const metricValue = this.toMetric(currentValue, currentUnit);
      input.value = this.formatNumber(this.fromMetric(metricValue, nextUnit));
    }
    this.units.set(field, nextUnit);
    input.closest('.hd-fit-entry__shell').querySelectorAll('[data-hd-fit-unit]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.hdFitUnit === nextUnit));
    });
    this.updateFieldHint(field);
    this.handleNumericInput(field);
  }

  handleNumericInput(field) {
    const input = this.inputs.get(field);
    const value = Number.parseFloat(input?.value);
    const valid = Number.isFinite(value) && value > 0;
    input?.setAttribute('aria-invalid', String(input.value !== '' && !valid));

    if (field === this.rule.fields[0]) {
      this.setNumericStepEnabled(valid);
      if (!valid) {
        this.inputs.get(this.rule.fields[1]).value = '';
        this.hideResult();
        return;
      }
    }

    const ready = this.rule.fields.every((label) => {
      const fieldValue = Number.parseFloat(this.inputs.get(label)?.value);
      return Number.isFinite(fieldValue) && fieldValue > 0;
    });
    if (ready) this.showNumericResult();
    else this.hideResult();
  }

  setNumericStepEnabled(enabled) {
    const field = this.rule.fields[1];
    const input = this.inputs.get(field);
    const shell = input?.closest('.hd-fit-entry');
    if (input) input.disabled = !enabled;
    shell?.classList.toggle('is-disabled', !enabled);
    shell?.querySelectorAll('[data-hd-fit-unit]').forEach((button) => {
      button.disabled = !enabled;
    });
  }

  showNumericResult() {
    const values = Object.fromEntries(this.rule.fields.map((field) => [field, this.getMetricValue(field)]));
    const matchingRows = this.rows.filter((row) => this.rule.fields.every((field) => this.rowFits(row, field, values[field])));
    if (matchingRows.length) {
      this.showRecommendedRow(this.chooseRow(matchingRows), values, false);
      return;
    }

    const primaryRows = this.rows.filter((row) => this.rowFits(row, this.rule.primary, values[this.rule.primary]));
    if (this.rule.allowLowerWeight && primaryRows.length) {
      const row = this.chooseRow(primaryRows);
      const weightValue = values['Pet weight'];
      const weightRange = this.getCellRange(row, 'Pet weight');
      if (Number.isFinite(weightValue) && weightRange && weightValue < weightRange.min) {
        this.showRecommendedRow(row, values, true);
        return;
      }
      if (Number.isFinite(weightValue) && weightRange && weightValue > weightRange.max) {
        this.showNoFit(`Your ${this.rule.primary.toLowerCase()} points to size ${row.size}, but the current weight is above its published limit.`, values);
        return;
      }
    }

    const primaryName = this.rule.primary.toLowerCase();
    const primaryFits = primaryRows.length > 0;
    this.showNoFit(
      primaryFits
        ? 'The two measurements do not fit the same listed size.'
        : `This ${primaryName} measurement does not fit any listed size.`,
      values,
    );
  }

  showRecommendedRow(row, values, weightCaution) {
    this.selectProductSize(row.size);
    const primary = this.rule.primary.toLowerCase();
    const copy = weightCaution
      ? `Your ${primary} measurement points to size ${row.size}. The weight is below its typical guide, so confirm every listed range and the two-finger fit before ordering.`
      : `Both entries support size ${row.size}. We selected it above; confirm every listed range below before adding it to your cart.`;
    this.showResult({
      size: row.size,
      title: `Size ${row.size} is your best starting point`,
      copy,
      spec: this.formatEnteredValues(values),
      note: weightCaution ? 'Confirm the full fit' : this.rule.resultNote,
      outOfRange: false,
    });
  }

  showNoFit(copy, values) {
    this.showResult({
      size: '—',
      title: 'No listed size safely matches both entries',
      copy: `${copy} Check your measurements once more or contact us before ordering.`,
      spec: this.formatEnteredValues(values),
      note: 'Do not guess the size',
      outOfRange: true,
    });
  }

  chooseRow(rows) {
    return this.rule.prefer === 'larger' ? rows[rows.length - 1] : rows[0];
  }

  rowFits(row, field, value) {
    const range = this.getCellRange(row, field);
    if (!range || !Number.isFinite(value)) return false;
    if (this.rule.capacityFields?.includes(field)) return value <= range.max;
    return value >= range.min && value <= range.max;
  }

  getCellRange(row, field) {
    const cell = row.cells.find((candidate) => candidate.label === field);
    if (!cell) return null;
    const rangeMatch = cell.text.match(/(\d+(?:\.\d+)?)\s*[–-]\s*(\d+(?:\.\d+)?)\s*(kg|cm)/i);
    if (rangeMatch) return { min: Number(rangeMatch[1]), max: Number(rangeMatch[2]) };
    const maxMatch = cell.text.match(/Up to\s*(\d+(?:\.\d+)?)\s*(kg|cm)/i);
    if (maxMatch) return { min: 0, max: Number(maxMatch[1]) };
    const exactMatch = cell.text.match(/(\d+(?:\.\d+)?)\s*(kg|cm)/i);
    if (exactMatch) return { min: Number(exactMatch[1]), max: Number(exactMatch[1]) };
    return null;
  }

  getMetricValue(field) {
    const input = this.inputs.get(field);
    return this.toMetric(Number.parseFloat(input.value), this.units.get(field));
  }

  toMetric(value, unit) {
    if (unit === 'lb') return value / 2.2046226218;
    if (unit === 'in') return value * 2.54;
    return value;
  }

  fromMetric(value, unit) {
    if (unit === 'lb') return value * 2.2046226218;
    if (unit === 'in') return value / 2.54;
    return value;
  }

  formatNumber(value) {
    return Number(value.toFixed(1)).toString();
  }

  formatEnteredValues(values) {
    return this.rule.fields.map((field) => {
      const unit = this.units.get(field);
      return `${this.formatNumber(this.fromMetric(values[field], unit))} ${unit}`;
    }).join(' · ');
  }

  updateFieldHint(field) {
    const hint = this.hints.get(field);
    const unit = this.units.get(field);
    const ranges = this.rows.map((row) => this.getCellRange(row, field)).filter(Boolean);
    if (!hint || !ranges.length) return;
    const min = Math.min(...ranges.map((range) => range.min));
    const max = Math.max(...ranges.map((range) => range.max));
    const visibleMin = this.fromMetric(min, unit);
    const visibleMax = this.fromMetric(max, unit);
    hint.textContent = min > 0
      ? `Published guide: ${this.formatNumber(visibleMin)}–${this.formatNumber(visibleMax)} ${unit}`
      : `Published maximum: ${this.formatNumber(visibleMax)} ${unit}`;
  }

  buildConfirmationFlow() {
    const row = this.rows[0];
    const hasWeight = Boolean(row.weight);
    const measurementLabel = row.measurement?.label || 'published dimensions';

    this.stepOneTitle.textContent = hasWeight
      ? '1. Is your pet within the listed weight limit?'
      : '1. Does this match what you need to carry?';
    this.stepOneCopy.textContent = hasWeight
      ? 'Use your pet’s current weight, not an estimate based on breed.'
      : 'Check the intended use before comparing the dimensions.';
    this.stepTwoTitle.textContent = `2. Have you checked the ${measurementLabel.toLowerCase()}?`;
    this.stepTwoCopy.textContent = 'Compare the published measurement with what you need before ordering.';
    this.stepOne.classList.add('hd-carrier-fit__choices--priority');
    this.stepTwo.classList.add('hd-carrier-fit__choices--priority');

    const firstPassLabel = hasWeight ? 'Yes, within range' : 'Yes, it matches';
    const firstPassDetail = hasWeight ? row.weight.text : 'Intended use confirmed';
    this.stepOne.append(this.createChoice('pass', firstPassLabel, firstPassDetail, false, (value) => {
      this.firstChoice = value;
      this.updatePressed(this.stepOne, value);
      this.setStepTwoEnabled(true);
      this.hideResult();
      if (this.secondChoice) this.showConfirmationResult(row);
    }));
    this.stepOne.append(this.createChoice('fail', 'No / not sure', hasWeight ? 'Do not size by guesswork' : 'Check the product details first', false, (value) => {
      this.firstChoice = value;
      this.secondChoice = '';
      this.updatePressed(this.stepOne, value);
      this.updatePressed(this.stepTwo, '');
      this.setStepTwoEnabled(false);
      this.showConfirmationResult(row);
    }));
    this.stepTwo.append(this.createChoice('pass', 'Yes, checked', row.measurement?.text || 'Published size reviewed', true, (value) => {
      this.secondChoice = value;
      this.updatePressed(this.stepTwo, value);
      this.showConfirmationResult(row);
    }));
    this.stepTwo.append(this.createChoice('fail', 'Not yet', 'Measure before ordering', true, (value) => {
      this.secondChoice = value;
      this.updatePressed(this.stepTwo, value);
      this.showConfirmationResult(row);
    }));
  }

  createChoice(value, label, detail, disabled, onSelect) {
    const button = document.createElement('button');
    const strong = document.createElement('strong');
    const span = document.createElement('span');
    button.type = 'button';
    button.dataset.hdFitChoice = value;
    button.setAttribute('aria-pressed', 'false');
    button.disabled = disabled;
    strong.textContent = label;
    span.textContent = detail;
    button.append(strong, span);
    button.addEventListener('click', () => onSelect(value));
    return button;
  }

  updatePressed(group, value) {
    group.querySelectorAll('[data-hd-fit-choice]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.hdFitChoice === value));
    });
  }

  setStepTwoEnabled(enabled) {
    this.stepTwo.querySelectorAll('button').forEach((button) => {
      button.disabled = !enabled;
    });
  }

  showConfirmationResult(row) {
    const match = this.firstChoice === 'pass' && this.secondChoice === 'pass';
    if (match) {
      this.showResult({
        size: '✓',
        title: 'The listed fit is a possible match',
        copy: 'Both checks are complete. Review the full specification card below once more before ordering.',
        spec: row.cells.slice(0, 2).map((cell) => cell.text).join(' · '),
        note: 'One size',
        outOfRange: false,
      });
      return;
    }

    const weightFailed = this.firstChoice === 'fail';
    this.showResult({
      size: '—',
      title: weightFailed ? 'This listing may not be the right fit' : 'Measure before ordering',
      copy: weightFailed
        ? 'Do not order this size until the listed limit and intended use both work for your pet.'
        : 'The dimension check is still incomplete. Compare the published measurements below before choosing.',
      spec: row.cells.slice(0, 2).map((cell) => cell.text).join(' · '),
      note: weightFailed ? 'Do not size down' : 'Check dimensions',
      outOfRange: true,
    });
  }

  selectProductSize(size) {
    const input = Array.from(document.querySelectorAll('variant-selects input[type="radio"]')).find((candidate) => {
      const optionName = candidate.name.trim().toLowerCase();
      return candidate.value === size && /size|尺寸/.test(optionName);
    });
    if (input && !input.checked) input.click();
  }

  showResult({ size, title, copy, spec, note, outOfRange }) {
    setHiDreamFitPurchaseState(outOfRange ? 'unconfirmed' : 'matched');
    this.result.hidden = false;
    this.result.classList.toggle('is-out-of-range', outOfRange);
    this.resultTitle.textContent = title;
    this.resultSize.textContent = size;
    this.resultCopy.textContent = copy;
    this.resultSpec.textContent = spec;
    this.resultNote.textContent = note;
  }

  hideResult() {
    this.result.hidden = true;
    setHiDreamFitPurchaseState('incomplete');
  }
}

document.querySelectorAll('[data-hd-fit-quiz]').forEach((root) => {
  new HiDreamFitQuiz(root);
});

class HiDreamMediaDisclosure {
  constructor(button) {
    this.button = button;
    this.gallery = button.closest('media-gallery');
    this.label = button.querySelector('[data-hd-media-toggle-label]');
    this.icon = button.querySelector('.hd-product-media-toggle__icon');
    this.total = Number(button.dataset.mediaTotal || 0);

    button.addEventListener('click', () => this.toggle());
  }

  toggle() {
    const expanded = !this.gallery.classList.contains('hd-product-media-expanded');
    this.gallery.classList.toggle('hd-product-media-expanded', expanded);
    this.button.setAttribute('aria-expanded', String(expanded));
    if (this.label) this.label.textContent = expanded ? 'Show fewer media' : `View all ${this.total} media`;
    if (this.icon) this.icon.textContent = expanded ? '−' : '+';
  }
}

document.querySelectorAll('[data-hd-media-toggle]').forEach((button) => {
  new HiDreamMediaDisclosure(button);
});

function normalizeJudgeMeControls(root) {
  root.querySelectorAll('.hd-product-rating-link .jdgm-prev-badge__stars').forEach((stars) => {
    stars.removeAttribute('role');
    stars.removeAttribute('tabindex');
  });

  root.querySelectorAll('.jdgm-histogram__star[role="button"]').forEach((stars) => {
    if (!/\(0\)/.test(stars.getAttribute('aria-label') || '')) return;
    stars.removeAttribute('role');
    stars.removeAttribute('tabindex');
    stars.setAttribute('aria-disabled', 'true');
  });
}

document.querySelectorAll('.hd-product-rating-link, #judgeme_product_reviews').forEach((root) => {
  normalizeJudgeMeControls(root);
  new MutationObserver(() => normalizeJudgeMeControls(root)).observe(root, { childList: true, subtree: true });
});

function initializeOptionDisclosures(root = document) {
  root.querySelectorAll('.product-form__input--pill').forEach((fieldset) => {
    if (fieldset.dataset.hdOptionDisclosureReady === 'true') return;
    if (!/colou?r/i.test(fieldset.querySelector('legend')?.textContent || '')) return;

    const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    if (inputs.length <= 6) return;

    const threshold = 5;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'hd-product-option-toggle';
    button.dataset.hdOptionToggle = '';
    fieldset.append(button);
    fieldset.dataset.hdOptionDisclosureReady = 'true';

    const update = (expanded = false) => {
      let hiddenCount = 0;
      inputs.forEach((input, index) => {
        const label = fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        const hide = !expanded && index >= threshold && !input.checked;
        input.hidden = hide;
        if (label) label.hidden = hide;
        if (hide) hiddenCount += 1;
      });
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? 'Show fewer colors' : `Show ${hiddenCount} more colors`;
    };

    button.addEventListener('click', () => update(button.getAttribute('aria-expanded') !== 'true'));
    update(false);
  });
}

initializeOptionDisclosures();

class HiDreamMobileAtc {
  constructor(root) {
    this.root = root;
    this.button = root.querySelector('[data-hd-mobile-atc-button]');
    this.label = root.querySelector('[data-hd-mobile-atc-label]');
    this.price = root.querySelector('[data-hd-mobile-atc-price]');
    this.mainSubmitId = root.dataset.mainSubmitId;
    this.raf = null;

    this.button?.addEventListener('click', () => this.activateMainSubmit());
    window.addEventListener('scroll', () => this.requestVisibilityUpdate(), { passive: true });
    window.addEventListener('resize', () => this.requestVisibilityUpdate(), { passive: true });
    if (this.mainSubmit) {
      this.submitObserver = new MutationObserver(() => this.sync());
      this.submitObserver.observe(this.mainSubmit, {
        attributes: true,
        attributeFilter: ['class', 'disabled', 'aria-disabled'],
        childList: true,
        subtree: true,
      });
    }
    this.sync();
    this.updateVisibility();
  }

  get mainSubmit() {
    return document.getElementById(this.mainSubmitId);
  }

  requestVisibilityUpdate() {
    if (this.raf) return;
    this.raf = requestAnimationFrame(() => {
      this.raf = null;
      this.updateVisibility();
    });
  }

  updateVisibility() {
    const submit = this.mainSubmit;
    const relatedProducts = document.querySelector('.hd-related-products-shell');
    const relatedProductsBounds = relatedProducts?.getBoundingClientRect();
    const relatedProductsInView = Boolean(
      relatedProductsBounds && relatedProductsBounds.top < window.innerHeight && relatedProductsBounds.bottom > 0,
    );
    const visible = Boolean(
      submit && window.innerWidth < 750 && submit.getBoundingClientRect().bottom < 0 && !relatedProductsInView,
    );
    this.root.classList.toggle('is-visible', visible);
    document.body.classList.toggle('hd-mobile-atc-visible', visible);
  }

  sync(variantData) {
    const submit = this.mainSubmit;
    if (!submit || !this.button) return;

    const isLoading = submit.classList.contains('loading') || submit.getAttribute('aria-disabled') === 'true';
    this.button.disabled = submit.disabled || isLoading;
    this.button.setAttribute('aria-busy', String(isLoading));
    this.root.classList.toggle('is-loading', isLoading);
    const mainLabel = submit.querySelector('span')?.textContent?.trim() || submit.textContent.trim();
    if (this.label) this.label.textContent = isLoading ? 'Adding\u2026' : mainLabel;

    if (variantData?.price?.amount && variantData.price.currencyCode && this.price) {
      const amount = Number(variantData.price.amount);
      if (Number.isFinite(amount)) {
        this.price.textContent = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: variantData.price.currencyCode,
        }).format(amount);
      }
    } else if (this.price) {
      const livePrice = document.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale');
      if (livePrice?.textContent.trim()) this.price.textContent = livePrice.textContent.trim();
    }
  }

  activateMainSubmit() {
    const submit = this.mainSubmit;
    if (!submit) return;
    if (submit.disabled) {
      document.querySelector('variant-selects')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    submit.click();
  }
}

const hdMobileAtc = document.querySelector('[data-hd-mobile-atc]');
const hdMobileAtcController = hdMobileAtc ? new HiDreamMobileAtc(hdMobileAtc) : null;

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    window.setTimeout(() => {
      initializeOptionDisclosures();
      hdMobileAtcController?.sync(data);
      hdMobileAtcController?.requestVisibilityUpdate();
    });
  });
}
